export default "__VITE_ASSET__34f43904__"